// Interart - rota da pagina admin "Etiqueta automatica" (dono do lead).
// Espelha labels/labels.routes.js e sla/sla.routes.js. Admin-only via meta.permissions.
// Destino no fonte: /opt/chatwoot-src/app/javascript/dashboard/routes/dashboard/settings/autotag/autotag.routes.js

import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/autotag'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'autotag_config_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'autotag_config_index', params: to.params };
          },
        },
        {
          path: 'index',
          name: 'autotag_config_index',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
  ],
};
